<template>
  <div v-if="page && page.total > 0" class="simple-pagination">
    <button
      class="pagination-arrow"
      :disabled="page.currentPage === 1"
      @click="changePage(page.currentPage - 1)"
    >
      <i class="bi bi-chevron-left"></i>
    </button>
    <span class="pagination-info">
      {{ page.from }}~{{ page.to }} / {{ page.lastPage }}
    </span>
    <button
      class="pagination-arrow"
      :disabled="page.currentPage === page.lastPage"
      @click="changePage(page.currentPage + 1)"
    >
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</template>

<script setup>
import Page from '../filters/Page';
import { colors } from '../../consts/colors';

const props = defineProps({
  page: {
    type: Page,
    required: true,
  }
});

const emit = defineEmits(['change']);

const changePage = (newPageNumber) => {
  if (newPageNumber >= 1 && newPageNumber <= props.page.lastPage) {
    emit('change', newPageNumber);
  }
};
</script>

<style lang="scss" scoped>
.simple-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding: 12px 0;
}

.pagination-info {
  font-size: 14px;
  color: v-bind('colors.textSecondary');
  font-weight: 500;
  min-width: 80px;
  text-align: center;
}

.pagination-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid v-bind('colors.gray[300]');
  background-color: v-bind('colors.white');
  color: v-bind('colors.textSecondary');
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background-color: v-bind('colors.gray[50]');
    border-color: v-bind('colors.gray[400]');
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  i {
    font-size: 14px;
  }
}
</style>
